<template>
  <div>
    <form class="form-horizontal">
      <h1 class="section-divider text-success">
        {{ $t('profileApproval.requestEdit') }}
      </h1>
      <div class="row" style="font-size: 12px">
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.nameKh')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_name_kh').edit
                }"
                >{{
                  checkKeyExist('father_name_kh').value
                    ? checkKeyExist('father_name_kh').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.nameEn')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_name_en').edit
                }"
                >{{
                  checkKeyExist('father_name_en').value
                    ? checkKeyExist('father_name_en').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.dateOfBirth') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_dob').edit }"
                >{{
                  checkKeyExist('father_dob').value
                    ? checkKeyExist('father_dob').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.nationality') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_nationality_id').edit
                }"
              >
                <select :value="checkKeyExist('father_nationality_id').value">
                  <option value>-</option>
                  <option
                    v-for="(nationality, index) in nationalities"
                    :key="index"
                    :value="nationality.id"
                  >
                    {{ nationality.nationality }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.religion') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_religion').edit
                }"
                >{{
                  checkKeyExist('father_religion').value
                    ? checkKeyExist('father_religion').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.occupation') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_occupation_id').edit
                }"
              >
                <select :value="checkKeyExist('father_occupation_id').value">
                  <option value>-</option>
                  <option
                    v-for="(occupation, index) in occupations"
                    :key="index"
                    :value="occupation.occupation_id"
                  >
                    {{ occupation.occupation_name_en }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.phoneLine1') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_phone1').edit }"
                >{{
                  checkKeyExist('father_phone1').value
                    ? checkKeyExist('father_phone1').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.phoneLine2') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_phone2').edit }"
                >{{
                  checkKeyExist('father_phone2').value
                    ? checkKeyExist('father_phone2').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.email') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_emails').edit }"
                >{{
                  checkKeyExist('father_emails').value
                    ? checkKeyExist('father_emails').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.facebook') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_facebook').edit
                }"
                >{{
                  checkKeyExist('father_facebook').value
                    ? checkKeyExist('father_facebook').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.line') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_line').edit }"
                >{{
                  checkKeyExist('father_line').value
                    ? checkKeyExist('father_line').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.linkIn') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_linked_in').edit
                }"
                >{{
                  checkKeyExist('father_linked_in').value
                    ? checkKeyExist('father_linked_in').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.telegram')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('father_telegram').edit
                }"
                >{{
                  checkKeyExist('father_telegram').value
                    ? checkKeyExist('father_telegram').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.wechat') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('father_wechat').edit }"
                >{{
                  checkKeyExist('father_wechat').value
                    ? checkKeyExist('father_wechat').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.province') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('province_code').edit }"
              >
                <select v-model="checkKeyExist('province_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(province, index) in provinces"
                    :value="province.province_code"
                    :key="index"
                  >
                    {{ province.province_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.district') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('district_code').edit }"
              >
                <select v-model="checkKeyExist('district_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(district, index) in districts"
                    :value="district.district_code"
                    :key="index"
                  >
                    {{ district.district_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.commune') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('commune_code').edit }"
              >
                <select v-model="checkKeyExist('commune_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(commune, index) in communes"
                    :value="commune.commune_code"
                    :key="index"
                  >
                    {{ commune.commune_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.village') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('village_code').edit }"
              >
                <select v-model="checkKeyExist('village_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(village, index) in villages"
                    :value="village.village_code"
                    :key="index"
                  >
                    {{ village.village_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.streetNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('street').edit }"
                >{{
                  checkKeyExist('street').value
                    ? checkKeyExist('street').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.houseNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('house_no').edit }"
                >{{
                  checkKeyExist('house_no').value
                    ? checkKeyExist('house_no').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div
                id="img-frame"
                :class="{
                  'background-blue': checkKeyExist('father_photo').edit
                }"
                class="text-center"
              >
                <img
                  v-lazy="{
                    src: photoFather(),
                    error: onErrorFather(),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 class="section-divider"></h1>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'fatherRequestEdit',
  props: ['info', 'edit'],
  data() {
    return {
      data: {},
      errors: new Errors(),
      manPhoto: require('../../../../../assets/staff-default-man.png'),
      file: require('../../../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('parentProfile', ['nationalities', 'occupations', 'provinces']),
    ...mapState('home/staffMyApproval', ['districts', 'communes', 'villages'])
  },
  methods: {
    photoFather() {
      return `/api/files?filePath=${this.checkKeyExist('father_photo').value}`
    },
    onErrorFather() {
      event ? (event.target.src = this.manPhoto) : ''
    },
    checkKeyExist(key) {
      let result = this.edit.filter(e => e.column_name == key)
      if (result.length > 0) {
        return {
          edit: true,
          value: result[0].new_value
        }
      }
      return {
        edit: false,
        value: this.info[key]
      }
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 45%;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
.background-blue img {
  background: #00acac;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
select {
  -webkit-appearance: none;
  appearance: none;
}

option {
  text-align: left;
}
</style>
